export default __webpack_public_path__ + "static/mountrail-county-1e8da6566d54032baa3d64467186349e.png";